module.exports = __webpack_public_path__ + "static/media/FiberousVeryThinRoot1.74f2eb2d.png";